<template>
    <div class="row" :style="{'--survey-panel-border-color': $store.getters.getSurveyPanelBorderColor}">
        <div class="col-lg-12">
            <div style="border-radius: 10px;padding:10px 10px 10px 10px;"
                 class="panel panel-default country-select-panel text-center" id="survey-panel">
                <div class="panel-body finish-panel-body">
                    <img src="/static/images/ok_yellow.png">
                    <br>
                    <div id="finishText" style="font-size:30px;">{{ $t("ui.finishText") }}</div>
                    <div v-if="$store.getters.getAccessToken" class="col-lg-12">
                        <router-link :to="{ name: 'Survey', params: { uid: uid }}">
                            <button type="button" class="btn btn-primary btn-lg"
                                    style="color:black !important;font-weight:bold;"
                                    v-bind:style="{ background: buttonBackground, color:$store.getters.getButtonTextColor}">
                                {{ $t("ui.againText") }}
                            </button>
                        </router-link>
                    </div>

                  <div class="small">{{ $t("ui.closePageText") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'finish',
        data() {
            return {
                uid: '',
                buttonBackground: ''
            }
        },
        mounted() {
            this.uid = this.$route.params.uid;
            this.buttonBackground = this.$store.getters.getButtonColor;

            if(this.$store.getters.getAutoRedirectToQuestionnaire) {
                setTimeout(() => {
                    this.$router.replace({name: 'Survey', params: {uid: this.uid}})
                }, 10000)
            }
        },
        methods: {},
        components: {}
    }
</script>
